import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5DerivativeBarriersEdit } from "./edit";
import { A5DerivativeBarriersNew } from "./new";
import { A5DerivativeBarriersTable } from "./table";
export default function A5DerivativeBarriers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Derivatives Barriers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5DerivativeBarriersEdit />} />
      <Route index element={<A5DerivativeBarriersTable />} />
      <Route path="/new" element={<A5DerivativeBarriersNew />} />
    </Routes>
  );
}
